import { useNavigate, useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { onboardingPath, sellingPath } from "../../core/primitives/onboarding";
import { OnboardingWebsiteController } from "./onboarding-website-controller";
import { OnboardingWebsitePage } from "./onboarding-website-page";

export function OnboardingWebsiteRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const claimOnboarding = searchParams.get("claimOnboarding") === "1";
  const storeIdParam = searchParams.get("storeId");
  return (
    <Subtree
      key="onboarding-website"
      deps={[claimOnboarding, storeIdParam]}
      controller={() =>
        new OnboardingWebsiteController(
          pick(deps, "client", "authHandler", "storeRepository", "locationsRepository"),
          { claimOnboarding, storeIdParam },
          {
            toPrevious: (storeId, claim) =>
              navigate(
                !claim && sellingPath(storeId) === "shows"
                  ? onboardingPath("show", storeId)
                  : onboardingPath("locations", storeId, claim),
              ),
            toPayments: (storeId, claim) => navigate(onboardingPath("payments", storeId, claim)),
          },
        )
      }
    >
      <OnboardingWebsitePage />
    </Subtree>
  );
}
